/* eslint-disable react/jsx-props-no-spreading */
import React, { useState, useRef } from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';

const Select = ({
  type = 'text',
  value,
  maxLength,
  onChange,
  onBlur,
  label,
  error,
  errorText,
  options,
  specialClass,
  loading,
  ...props
}) => {
  const ref = useRef();
  const [isFocus, setIsFocus] = useState(false);

  return (
    <>
      <div className={`input-field input-select ${loading ? 'relative' : ''}`}>
        <select
          className={`${cn({ error })} ${specialClass} ${loading ? 'loading' : ''}`}
          ref={ref}
          autoComplete="off"
          value={value}
          type={type}
          maxLength={maxLength}
          onChange={({ target }) => onChange(target.value)}
          onFocus={() => setIsFocus(true)}
          onBlur={() => {
            setIsFocus(false);
            onBlur();
          }}
          {...props}
        >
          <option value="" disabled>{label}</option>
          {options}
        </select>
        {loading && <span className="spin" />}
        <label
          onClick={() => ref.current.focus()}
          className={cn({ active: value !== '' || isFocus })}
        >
          {label}
        </label>
      </div>
      {error && (
        <span className="show-error">{errorText}</span>
      )}
    </>
  );
};

Select.defaultProps = {
  type: 'text',
  maxLength: '',
  onBlur: () => { },
  label: '',
  error: false,
  errorText: '',
  options: [],
  specialClass: '',
};

Select.propTypes = {
  type: PropTypes.string,
  value: PropTypes.string.isRequired,
  maxLength: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  label: PropTypes.string,
  error: PropTypes.bool,
  errorText: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({})),
  specialClass: PropTypes.string,
  loading: PropTypes.bool.isRequired,
};

export default Select;
